/* eslint-disable no-unused-vars */
import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from 'react';
import {
  EPurchaseProductType,
  ICreateOrderResponse,
} from '../../../interfaces/order.interface';
import OrderInfo from './OrderInfo';
import PaymentMethod from './PaymentMethod';
import TransactionInfo from './TransactionInfo';

export enum EPurchaseSectionStep {
  OrderInfo = 'OrderInfo',
  PaymentMethod = 'PaymentMethod',
  TransactionInfo = 'TransactionInfo',
}

export const PurchaseSectionContext = createContext<{
  openStep: EPurchaseSectionStep | undefined;
  setOpenStep: (_: EPurchaseSectionStep | undefined) => void;
  order: ICreateOrderResponse;
  setOrder: Dispatch<SetStateAction<ICreateOrderResponse>>;
  price: number;
  productId: string;
  productType: EPurchaseProductType;
}>({
  openStep: undefined,
  setOpenStep: () => {},
  order: {
    orderCode: '',
    orderId: '',
  },
  setOrder: () => {},
  price: 0,
  productId: '',
  productType: EPurchaseProductType.Course,
});

interface IPurchaseSection {
  open: boolean;
  toggle: () => void;
  price: number;
  productId: string;
  productType: EPurchaseProductType;
}

const PurchaseSectionProvider: React.FC<IPurchaseSection> = ({
  children,
  open,
  toggle,
  price,
  productId,
  productType,
}) => {
  const [openStep, setOpenStep] = useState<EPurchaseSectionStep | undefined>(
    undefined
  );

  const [order, setOrder] = useState<ICreateOrderResponse>({
    orderCode: '',
    orderId: '',
  });

  useEffect(() => {
    if (open) {
      setOpenStep(EPurchaseSectionStep.OrderInfo);
    }
  }, [open]);

  return (
    <PurchaseSectionContext.Provider
      value={{
        openStep,
        setOpenStep: (_: EPurchaseSectionStep | undefined) => {
          if (!_) toggle();
          setOpenStep(_);
        },
        order,
        setOrder,
        price,
        productId,
        productType,
      }}
    >
      {children}
    </PurchaseSectionContext.Provider>
  );
};

const PurchaseSection = ({
  children,
  ...props
}: PropsWithChildren<IPurchaseSection>) => {
  return (
    <PurchaseSectionProvider {...props}>
      <OrderInfo>{children}</OrderInfo>
      <PaymentMethod />
      <TransactionInfo />
    </PurchaseSectionProvider>
  );
};

export default PurchaseSection;
